import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CursAbcHero } from '../components/cursabc/CursAbcHero';
import { CursAbcProblem } from '../components/cursabc/CursAbcProblem';
import { CursAbcCurriculum } from '../components/cursabc/CursAbcCurriculum';
import { CursAbcBenefits } from '../components/cursabc/CursAbcBenefits';
import { CursAbcAbout } from '../components/cursabc/CursAbcAbout';
import { CursAbcForWho } from '../components/cursabc/CursAbcForWho';
import { CursAbcPricing } from '../components/cursabc/CursAbcPricing';
import { CursAbcTestimonials } from '../components/cursabc/CursAbcTestimonials';
import { CursAbcFAQ } from '../components/cursabc/CursAbcFAQ';
export function CursAbcPage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2314">
      <Header data-id="element-2315" />
      <main data-id="element-2316">
        <CursAbcHero data-id="element-2317" />
        <CursAbcProblem data-id="element-2318" />
        <CursAbcCurriculum data-id="element-2319" />
        <CursAbcBenefits data-id="element-2320" />
        <CursAbcAbout data-id="element-2321" />
        <CursAbcForWho data-id="element-2322" />
        <CursAbcPricing data-id="element-2323" />
        <CursAbcTestimonials data-id="element-2324" />
        <CursAbcFAQ data-id="element-2325" />
      </main>
      <Footer data-id="element-2326" />
    </div>;
}